import { XOR } from "ts-xor";
import RatingTile from "../RatingTile/RatingTile";
import "./EpcRatingTile.scss";

type EpcRatingTilePropsWithGrade = {
	grade: string;
	compact?: boolean;
};

/**
 * @deprecated Use grade parameter instead
 */
type EpcRatingTilePropsWithRating = {
	rating: number;
	compact?: boolean;
};

type EpcRatingTileProps = XOR<EpcRatingTilePropsWithGrade, EpcRatingTilePropsWithRating>;

export default function EpcRatingTile({ grade, rating, compact }: EpcRatingTileProps) {
	let letter;

	if (rating != null) {
		const ratingRound = Math.round(rating);
		if (isNaN(rating)) {
			console.error("Invalid rating: " + rating);
			return <></>;
		}

		if (ratingRound < 0) {
			console.error(`EPC rating ${ratingRound} out of bounds`);
			return <></>;
		}

		// We should move away from having these values hard coded in the front end
		if (ratingRound > 91) letter = "A";
		else if (ratingRound >= 81) letter = "B";
		else if (ratingRound >= 69) letter = "C";
		else if (ratingRound >= 55) letter = "D";
		else if (ratingRound >= 39) letter = "E";
		else if (ratingRound >= 21) letter = "F";
		else letter = "G";
	} else letter = grade;

	return (
		<RatingTile className="epc-rating-tile" compact={compact} data-grade={letter}>
			{!compact && letter}
		</RatingTile>
	);
}
